import { EmailSourceType } from '@/enums/ProfileContacts';
import { MutationFn } from '@/lib/datx-jsonapi-react/interfaces/MutaionFn';
import { ProfileContact } from '@/resources/ProfileContact';
import { AppCollection } from '@/stores/AppStore';

export interface IMessageInfo {
  sender_name: string;
  sender_email: string;
  recipient_email: string;
  message: string;
}

export interface IProfileContactInput {
  lectureId?: string;
  eventId?: string;
  message_info: IMessageInfo;
  source: EmailSourceType;
}

export const sendProfileEmail: MutationFn<IProfileContactInput, ProfileContact> = (
  store,
  { lectureId, eventId, message_info, source }: IProfileContactInput
) => {
  const relationships: Record<string, object> = {};

  if (lectureId) {
    relationships.lecture = {
      type: 'lectures',
      data: {
        id: lectureId,
      },
    };
  }

  if (eventId) {
    relationships.event = {
      type: 'events',
      data: {
        id: eventId,
      },
    };
  }

  return store.request(`profile_contacts?source=${source}`, 'POST', {
    data: {
      type: ProfileContact.type,
      attributes: message_info,
      relationships,
    },
  });
};
